import { ResponseConstants } from '../ResponseConstants';

export function getChangeStatusFailureMessage(
  isExecuteOrRetry: boolean,
  errorCode: number | undefined,
  actionsCount: number,
  responseConstants: ResponseConstants
): string {
  if (!isExecuteOrRetry) {
    return responseConstants.GENERAL_FAILED_MESSAGE;
  }
  if (ResponseConstants.ERROR_CODE_NO_ENABLED_SENSORS === errorCode) {
    return responseConstants.RESPONSE_ACTIONS_NO_SENSORS;
  }
  if (ResponseConstants.ERROR_CODE_RESPONSE_ACTIONS_DISABLED_FOR_SENSOR === errorCode) {
    return 1 === actionsCount
      ? responseConstants.RESPONSE_ACTIONS_DISABLED_FOR_SENSOR_FAILED_MESSAGE_SINGULAR
      : responseConstants.RESPONSE_ACTIONS_DISABLED_FOR_SENSOR_FAILED_MESSAGE_PLURAL;
  }

  return 1 === actionsCount
    ? responseConstants.EXECUTE_AND_RETRY_FAILED_MESSAGE_SINGULAR
    : actionsCount + responseConstants.EXECUTE_AND_RETRY_FAILED_MESSAGE_PLURAL;
}
